import React from 'react'

export default () => (
  <svg
    width="27"
    height="24"
    viewBox="0 0 27 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26 8.595C26 4.4 22.995 1 19.29 1c-2.468 0-4.624 1.507-5.79 3.752C12.334 2.507 10.178 1 7.71 1 4.006 1 1 4.4 1 8.595v.098c0 5.606 12.53 13.824 12.53 13.824S26 14.298 26 8.692V8.66v-.065"
      stroke="#454545"
      fill="none"
      fillRule="evenodd"
    />
  </svg>
)



// WEBPACK FOOTER //
// ./src/icons/followIcon.js